import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGroup } from "../../../interfaces/models/IGroup";

const initialState: IGroup[] = [];

export const groupsSlice = createSlice({
  name: "groups",
  initialState,
  reducers: {
    SetGroups: (_, action: PayloadAction<IGroup[]>) => action.payload,
    AddGroup: (state, action: PayloadAction<IGroup>) => {
      state.push(action.payload);
    },
    UpdateGroup: (state, action: PayloadAction<IGroup>) => {
      const index = state.findIndex((group) => group.id === action.payload.id);
      if (index !== -1) {
        state[index] = { ...state[index], ...action.payload };
      }
    },
    DeleteGroup: (state, action: PayloadAction<string>) => {
      return state?.filter((group) => group.id !== action.payload);
    },
  },
});

export const { SetGroups, AddGroup, UpdateGroup, DeleteGroup } = groupsSlice.actions;
